import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=68324d2e&scoped=true"
import script from "./AppFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./AppFooter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=68324d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68324d2e",
  null
  
)

export default component.exports